const videoControl = {

	$window: $(window),
	elem: {
		$controls: $('[data-video-controls]')
	},

	init() {
		this.elem.$controls.each(function(){
		  
		  let $video = $('#' + $(this).attr('data-video-controls'))[0];

		  if (window.matchMedia('(prefers-reduced-motion)').matches) {

		    if(!$($video).attr('data-play-sm')) {
		      $video.removeAttribute('autoplay');
		      $video.pause();
		      $(this).addClass('paused');
		    }
		  }

		  $(this).on('click', function(e){
		    e.preventDefault();
		    if($video.paused) {
		      $(this).removeClass('paused');
		      $video.play();
		      return;
		    } 
		    
		    $(this).addClass('paused');
		    $video.pause();

		  });
		});
	},
	bindUIActions() {

	}
};

export { videoControl };
